export default __webpack_public_path__ + "static/media/jeongyeon2.8e55a635.jpg";